<template>
  <div class="checkout-section payment-page" :class="[ paymentMethod ]">
    <h1 class="page-title text-center">ชำระเงิน</h1>

    <div class="modal" tabindex="-1" role="dialog" ref="termsModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">เงื่อนไขและนโยบายการชำระเงิน</h5>
          </div>
          <div class="modal-body">
            <!-- wp:paragraph -->
            <p>การทำรายการบริจาคบนเว็บไซต์ <a href="https://donate.eef.or.th">donate.eef.or.th</a></p>
            <!-- /wp:paragraph -->

            <!-- wp:list {"ordered":true,"className":"content-md"} -->
            <ol class="content-md"><li>เว็บไซต์ <a href="https://donate.eef.or.th">donate.eef.or.th</a>&nbsp;จะไม่ได้เก็บข้อมูลบัตรเครดิต หรือบัตรเดบิต ตามมาตรฐานความปลอดภัยสากล ยกเว้นวันหมดอายุ และเลข 4 หลักสุดท้ายของหมายเลขบัตรเครดิต เพื่อใช้เป็นข้อมูลอ้างอิงการทำรายการ</li><li>เว็บไซต์ใช้บริการช่องทางการชำระเงิน (Payment Gateway) ของ TMB ซึ่งเป็นผู้ให้บริการที่ได้รับมาตรฐานความปลอดภัยในการชำระเงินออนไลน์ผ่านบัตรเครดิตและบัตรเดบิต</li><li>ข้อมูลส่วนตัวของผู้บริจาคหรือสมาชิก จะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ และสามารถใช้ข้อมูลเพื่อติดต่อไปยังผู้บริจาคหรือสมาชิกได้ ภายใต้จุดประสงค์ที่เกี่ยวข้องกับการดำเนินงานของกองทุนเพื่อความเสมอภาคทางการศึกษา</li><li>ยินยอมให้ กองทุนเพื่อความเสมอภาคทางการศึกษา เก็บ รวบรวม ใช้ ข้อมูลส่วนบุคคล เพื่อการวิจัย ติดตาม และพัฒนาการแนวทางการรับบริจาค เพื่อบรรลุวัตถุประสงค์ในลดความเหลื่อมล้ำสร้างความเสมอภาคทางการศึกษา</li><li>หากผู้บริจาคมีความประสงค์จะยกเลิกรายการชำระเงินใดๆ สามารถติดต่อฝ่ายข้อมูลผู้สนับสนุนของ กองทุนเพื่อความเสมอภาคทางการศึกษา ได้ที่ หมายเลขโทรศัพท์ 02-079-5475 (วันจันทร์ - ศุกร์ ติดต่อในเวลาราชการ)</li></ol>
            <!-- /wp:list -->
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="hideTermsModal">ปิด</button>
          </div>
        </div>
      </div>
    </div>

    <donate-step-bar @clickstep="onStep"/>
    <div class="container pd-sm-0 mt-3" v-if="!$utils.isCartEmpty()">
      <payment-summary class="show-sm" v-if="false"></payment-summary>

      <div class="with-sidebar">
        <div class="content">
          <div class="sidebar block-border block radius show-sm mb-3">
            <div class="summary__row--lg" v-for="cart in $store.state.cart">
              <div class="title mb-2 mb-md-3">{{ $store.state.donateType === 'monthly' ? 'บริจาครายเดือนให้กับ' : 'บริจาคให้กับ' }}</div>
              <div class="summary__label">{{ cart.product.name }}</div>
              <div class="summary__value">{{ cart.product.price | comma }} <span class="txt-normal">บาท</span></div>
            </div>
          </div>

          <div class="block-primary block radius b-email mb-4">
            <h2 class="block__title">ข้อมูลยืนยันการบริจาค</h2>

            <!-- <div class="form__item"> -->
            <div class="form__item--block">
              <label class="form__label" for="email">อีเมล</label>
              <input class="form__text" type="text" name="email" id="email" v-model="email" required :class="{ 'form__input--error': $v.isError('email') }" />
              <div class="alert alert--error" v-show="$v.$errors.email.empty">กรุณากรอกอีเมล</div>
              <div class="alert alert--error" v-show="$v.$errors.email.invalid">กรุณากรอกอีเมลให้ถูกต้อง</div>
              <div class="alert alert--error" v-show="$v.$errors.email.facebookEmail">กรุณากรอกอีเมลที่ใช้ได้จริง ไม่อนุญาตให้ใช้อีเมลของ Facebook</div>
              <div class="form__item form__item--inline">
                <input class="form__input" type="checkbox" name="accept" id="accept" />
                <label class="form__label -font-light text-dark" for="accept">ยินดีรับข้อมูลข่าวสารจาก กสศ. ทางอีเมล</label>
              </div>
            </div>

            <div class="form__item--block">
              <label class="form__label" for="phone">เบอร์ติดต่อ</label>
              <input class="form__text" type="text" name="phone" id="phone" v-model="phone" required pattern="[0-9\-\+]*" :class="{ 'form__input--error': $v.isError('phone') }" />
              <div class="alert alert--error" v-show="$v.$errors.phone.empty">กรุณากรอกเบอร์ติดต่อ</div>
              <div class="alert alert--error" v-show="!$v.$errors.phone.empty && $v.$errors.phone.invalid">กรุณากรอกเบอร์ติดต่อให้ถูกต้อง</div>
            </div>

          </div>

          <div class="block-primary block radius">
            <form class="form" @submit.prevent="submit()" novalidate>
              <h2 class="block__title">ช่องทางการบริจาค</h2>
              <!-- <p class="text-muted-ss">ข้อมูลเกี่ยวกับการชำระเงินจะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ</p> -->

              <div class="alert alert--error" v-show="$v.$errors.paymentMethod.empty">กรุณาเลือกวิธีการบริจาค</div>

              <div class="form__wrapper">

                <div class="form__section" @click="paymentMethod = 'thaiqr'; taxInfoTab = 'person'" v-if="isPaymentMethodEnable('thaiqr')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="thaiqr" v-model="paymentMethod" value="thaiqr" />
                    <label class="form__label form__label--title" for="thaiqr">QR Code ผ่าน Mobile Banking App</label>
                    <div class="block--icon-bank">
                      <img src="/static/img/icons/ic-banking-new.png" srcset="/static/img/icons/ic-banking-new.png 1x, /static/img/icons/ic-banking-new@2x.png 2x" alt="Mobile Banking" class="img-fluid" style="max-height: 60px;" />
                    </div>
                  </div>
                  <transition name="slide-down" v-if="isPaymentMethodEnable('thaiqr')">
                    <div class="slide-down-wrapper" v-show="isThaiQR">
                      <div class="block-third slide-down-item">
                        <div class="form__item--inline">
                          <div>
                            <ul class="text-muted-ss">
                              <li>ชำระผ่านการสแกน QR code ด้วย Mobile Banking Application ของธนาคารที่กำหนด</li>
                              <li>ผู้บริจาคจะได้ QR Code หลังจากกดปุ่มยืนยันการบริจาค</li>
                              <li>การบริจาคผ่าน QR Code ในโครงการ e-Donation ข้อมูลการบริจาคของคุณจะถูกส่งไปกรมสรรพากรเพื่อลดหย่อนภาษีโดยอัตโนมัติ</li>
                              <li>ท่านสามารถตรวจสอบรายการบริจาคในระบบกรมสรรพากรหลังจากบริจาคแล้ว 3-7 วัน <a href="https://epayapp.rd.go.th/rd-edonation/portal/for-donor" target="_blank">ได้ที่นี่</a></li>
                            </ul>

                          </div>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div>

                <!-- BANK TRANSFER -->
                <div class="form__section" @click="paymentMethod = 'bank_transfer'" v-if="isPaymentMethodEnable('bank_transfer')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="tranfer" v-model="paymentMethod" value="bank_transfer" />
                    <label class="form__label form__label--title" for="tranfer">โอนเงินผ่านบัญชีธนาคาร</label>
                    <span class="block--icon-bank">
                      <span v-for="bank in $config.BANK_TRANSFER" class="block__img__wrapper">
                        <img v-if="bank[0] == 'promptpay'" src="../assets/img/icon/promptpay.jpg" height="25" :alt="bank[1]"   />
                        <img v-else :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="25" height="25" :alt="bank[1]"   />
                      </span>
                    </span>
                  </div>
                  <transition name="slide-down" v-if="isPaymentMethodEnable('bank_transfer')">
                    <div class="slide-down-wrapper" v-show="isTransfer">
                      <div class="block-third slide-down-item">
                        <div class="form__item--inline">
                          <div class="block--transfer border p-2 rounded" v-for="bank in $config.BANK_TRANSFER">
                            <div v-if="bank[0] == 'promptpay'" class="block__flex promptpay__wrapper" >
                              <img class="ic-promptpay" src="../assets/img/icon/promptpay.jpg" height="40" :alt="bank[1]"  />
                              <div class="promptpay--detail">{{ bank[1] }} ชื่อบัญชี: {{ bank[2] }}<br />รหัส {{ bank[3] }} (เลขประจำตัวผู้เสียภาษี)</div>
                            </div>
                            <div v-else class="block__flex" >
                              <!-- <img :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="40" :alt="bank[1]"  /> -->
                              <div>{{ bank[1] }} ชื่อบัญชี: {{ bank[2] }}<br />เลขบัญชี {{ bank[3] }}</div>
                            </div>
                          </div>

                          <div class="block__flex">
                            <i class="alert__icon icon-info"></i>
                            <div class="alert__text">เมื่อชำระเงินเรียบร้อยแล้ว สามารถยืนยันการโอนเงินจากแบบฟอร์มในขั้นตอนถัดไป หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</div>
                          </div>
                        </div>
                        <div class="block text-muted pd-15 font-sm">
                          <ul class="ma-0">
                            <li>เตรียมหลักฐานการโอนเงินเป็นรูปภาพหรือรูปถ่าย เช่น รูปถ่ายใบเสร็จการโอนเงินจากตู้ ATM หรือรูปภาพหน้าจอในกรณีที่ทำธุรกรรมออนไลน์</li>
                            <li>ไม่มีค่าธรรมเนียมการโอน</li>
                            <li>ผู้บริจาคต้องแนบหลักฐานการโอนเงินภายใน 3 วันหลังจากทำรายการสำเร็จ</li>
                          </ul>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div>

                <!-- CREDIT CARD -->
                <div class="form__section" v-if="isPaymentMethodEnable('credit_card')">
                  <div class="form__item form__item--inline" @click="paymentMethod = 'credit_card'">
                    <input class="form__input" type="radio" id="creditcard" v-model="paymentMethod" name="payment_method" value="credit_card" />
                    <label class="form__label form__label--title" for="creditcard">Credit Card / Debit Card</label>
                    <div class="block--icon-bank">
                      <img :src="$utils.svg(require('../assets/img/ic-visa.svg'))" alt="Visa" height="18" />
                      <img :src="$utils.svg(require('../assets/img/ic-mastercard.svg'))" alt="Master Card" height="20" />
                    </div>
                  </div>
                  <transition name="slide-down" v-if="isPaymentMethodEnable('credit_card')">
                    <div class="slide-down-wrapper" v-show="isCreditCard">
                      <div class="block-third slide-down-item">
                        <div class="mt-15 text-left">
                          <ul class="text-muted-ss">
                            <li>ชำระเงินผ่านบัตรเครดิต / บัตรเดบิต VISA, Master Card</li>
                            <li>ข้อมูลบัตรจะถูกดำเนินการอย่างปลอดภัยด้วยผู้ให้บริการที่ผ่านมาตรฐาน</li>
                          </ul>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div><!-- end form section -->

                <transition name="slide-down" v-if="false">
                  <div class="slide-down-wrapper" v-show="isCreditCard">
                    <div class="form__section block-third slide-down-item">
                      <div class="form__item">
                        <label class="form__label" for="id-creditcard">หมายเลขบัตร 16 หลัก</label>
                        <input class="form__input" type="text" name="id-creditcard" id="id-creditcard"
                               v-model="ccNumber" :required="useCreditCard"
                               v-on:keydown="validateCreditCardKey"
                               v-on:input="updateCreditCardValue"
                               autocomplete="new-password"
                               :readonly="!formReady"
                               :class="{ 'form__input--error': $v.isError('ccNumber') }" />

                        <div class="alert alert--error" v-show="$v.$errors.ccNumber.empty">กรุณากรอกหมายเลขบัตร</div>
                        <div class="alert alert--error" v-show="$v.$errors.ccNumber.invalid">กรุณากรอกหมายเลขบัตรให้ถูกต้อง</div>
                        <i class="lock__icon icon-lock"></i>
                      </div>
                      <div class="form__item">
                        <label class="form__label" for="name-creditcard">ชื่อผู้ถือบัตร</label>
                        <input class="form__input" type="text" value="" name="name-creditcard" id="name-creditcard"
                               v-model="ccHolderName"
                               v-on:keydown="validateCreditCardHolderKey"
                               v-on:input="updateCreditCardHolder"
                               :required="useCreditCard"
                               :readonly="!formReady"
                               :class="{ 'form__input--error': $v.isError('ccHolderName') }" />
                        <div class="alert alert--error" v-show="$v.$errors.ccHolderName.empty">กรุณากรอกชื่อผู้ถือบัตร</div>
                      </div>
                      <div class="form__item">
                        <label class="form__label" for="expired">MM/YY</label>
                        <input class="form__input" type="text" value="" name="expired" id="expired"
                               v-model="ccExpired" :required="useCreditCard" pattern="[0-9]{2}/[0-9]{2}"
                               :readonly="!formReady"
                               v-on:keydown="validateExpiredKey"
                               v-on:input="updateExpiredValue($event.target.value)"
                               :class="{ 'form__input--error': $v.isError('ccExpired') }" />
                        <div class="alert alert--error" v-show="$v.$errors.ccExpired.empty">กรุณากรอกเดือน/ปีที่หมดอายุ</div>
                        <div class="alert alert--error" v-show="$v.$errors.ccExpired.invalid">กรุณากรอกเดือน/ปีให้ถูกต้อง</div>
                      </div>
                      <div class="form__item--securitycode w-30">
                        <div class="form__item">
                          <label class="form__label" for="cvv">CVV</label>
                          <input class="form__input" type="password" value="" name="cvv" id="cvv"
                                 v-model="ccCVV" :required="useCreditCard"
                                 v-on:keydown="validateCVVKey"
                                 autocomplete="new-password"
                                 :readonly="!formReady"
                                 :class="{ 'form__input--error': $v.isError('ccCVV') }" />
                          <div class="alert alert--error" v-show="$v.$errors.ccCVV.empty">กรุณากรอกรหัสหลังบัตร 3 หลัก</div>
                          <div class="alert alert--error" v-show="$v.$errors.ccCVV.invalid">กรุณากรอกรหัสหลังบัตรให้ถูกต้อง</div>
                        </div>
                        <a class="tooltips"><i class="icon-help"><span class="data">รหัสความปลอดภัยหลังบัตร 3 หลัก</span></i></a>
                      </div>

                      <div class="mt-15 text-center">
                        <ul class="text-muted-ss">
                          <li>ชำระเงินผ่านบัตรเครดิต / บัตรเดบิต VISA, Master Card,</li>
                          <li>ข้อมูลบัตรจะถูกดำเนินการอย่างปลอดภัยด้วยผู้ให้บริการที่ผ่านมาตรฐาน</li>
                        </ul>
                      </div>

                    </div> <!-- end form_section -->
                  </div>
                </transition>

                <!-- LINE PAY -->
                <div class="form__section" @click="paymentMethod = 'line_pay'" v-if="isPaymentMethodEnable('line_pay')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="line_pay" v-model="paymentMethod" value="line_pay" />
                    <label class="form__label form__label--title" for="line_pay">Rabbit LINE Pay</label>
                    <div class="block--icon-bank">
                      <img src="/static/img/icons/ic-line_pay.png" srcset="/static/img/icons/ic-line_pay.png 1x, /static/img/icons/ic-line_pay@2x.png 2x" alt="Rabbit LINE Pay" height="22" />
                    </div>
                  </div>
                  <transition name="slide-down" v-if="isPaymentMethodEnable('line_pay')">
                    <div class="slide-down-wrapper" v-show="isLinePay">
                      <div class="block-third slide-down-item">
                        <div class="form__item--inline">
                          <div>
                            <ul class="text-muted-ss">
                              <li>สามารถชำระเงินด้วยบัตรเดบิต / เครดิต หรือช่องทางอื่นๆ ของ Rabbit LINE Pay ได้ </li>
                              <li>Rabbit LINE Pay พร้อมให้บริการใน LINE App ตั้งแต่เวอร์ชั่น 4.8.0 ใน iPhone และ ตั้งแต่เวอร์ชั่น 5.4.1 ใน Android</li>
                            </ul>

                          </div>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div>


                <!-- INTERNET BANKING -->
                <div class="form__section" @click="paymentMethod = 'internet_banking'" v-if="isPaymentMethodEnable('internet_banking')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="internet_banking" v-model="paymentMethod" value="internet_banking" />
                    <label class="form__label form__label--title" for="internet_banking">Internet Banking</label>
                    <span class="block--icon-bank">
                    <img v-for="bank in $config.OMISE_INTERNET_BANKING" :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="25" height="25" :alt="bank[1]"   />
                  </span>
                  </div>
                  <transition name="slide-down" v-if="isPaymentMethodEnable('internet_banking')">
                    <div class="slide-down-wrapper" v-show="isInternetBanking">
                      <div class="block-third slide-down-item">
                        <div class="form__item--inline">
                          <div class="alert alert--error" v-show="$v.$errors.internetBankingOffsite.empty">กรุณาเลือกธนาคาร</div>
                          <div class="block__flex block--internet_banking" v-for="bank in $config.OMISE_INTERNET_BANKING">
                            <div class="radio">
                              <input type="radio" name="offsite" v-model="internetBankingOffsite" :id="`offsite_${ bank[0] }`" :value="`internet_banking_${ bank[0] }`" :required="isInternetBanking">
                              <label :for="`offsite_${ bank[0] }`">
                                <img :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="40" :alt="bank[1]"  />
                                <strong>{{ bank[1] }}</strong>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div>


                <!-- 2C2P 123 -->
                <div class="form__section" @click="paymentMethod = '2c2p:123'" v-if="isPaymentMethodEnable('2c2p:123')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="2c2p_123" v-model="paymentMethod" value="2c2p:123" />
                    <label class="form__label form__label--title" for="internet_banking">Internet banking / Counter / ATM</label>
                    <span class="block--icon-bank">
                      <span v-for="bank in $config.OMISE_INTERNET_BANKING" class="block__img__wrapper">
                        <img :class="'block__img block__img--' + bank[0]" :src="$utils.svg(require('../assets/img/thaibank/' + bank[0] + '.svg'))" width="25" height="25" :alt="bank[1]"   />
                      </span>
                    </span>
                    <span class="block--icon-bank">
                      <img src="/static/img/icons/tesco-lotus_logo.png" srcset="/static/img/icons/tesco-lotus_logo.png 1x, /static/img/icons/tesco-lotus_logo@2x.png 2x" alt="Tesco Lotus" height="22" />
                      <img src="/static/img/icons/big-c_logo.png" srcset="/static/img/icons/big-c_logo.png 1x, /static/img/icons/big-c_logo@2x.png 2x" alt="Big C" height="22" />
                      <img src="/static/img/icons/paypost_logo1.png" srcset="/static/img/icons/paypost_logo1.png 1x, /static/img/icons/paypost_logo1@2x.png 2x" alt="PayPost" height="22" />
                      <img src="/static/img/icons/mpay-station_logo.png" srcset="/static/img/icons/mpay-station_logo.png 1x, /static/img/icons/mpay-station_logo@2x.png 2x" alt="M Pay" height="22" />
                      <img src="/static/img/icons/tw_logo.png" srcset="/static/img/icons/tw_logo.png 1x, /static/img/icons/tw_logo@2x.png 2x" alt="true money" height="22" />
                      <img src="/static/img/icons/cenpay_logo.png" srcset="/static/img/icons/cenpay_logo.png 1x, /static/img/icons/cenpay_logo@2x.png 2x" alt="Cen Pay" height="22" />
                      <img src="/static/img/icons/boonterm_logo.png" srcset="/static/img/icons/boonterm_logo.png 1x, /static/img/icons/boonterm_logo@2x.png 2x" alt="บุญเติม" height="22" />
                    </span>
                  </div>
                  <transition name="slide-down" v-if="isPaymentMethodEnable('2c2p:123')">
                    <div class="slide-down-wrapper" v-show="is2C2P123">
                      <div class="block-third slide-down-item">
                        <div class="form__item--inline">
                          <div>
                            <ul class="text-muted-ss">
                              <li>สามารถชำระเงินผ่านบริการออนไลน์ของธนาคารได้ดังนี้ ธนาคารไทยพาณิชย์, ธนาคารกรุงไทย, ธนาคารทหารไทย, ​ธนาคารยูโอบี,​ ธนาคารกรุงศรีอยุธยา,​ ธนาคารกรุงเทพ,  ธนาคารกสิกรไทย และธนาคารธนชาติ​</li>
                              <li>สามารถชำระเงินผ่านเคาน์เตอร์ของตัวแทนได้ดังนี้ Tesco Lotus, Big C, Pay@Post, MPAY, TrueMoney, CENPAY และตู้บุญเติม</li>
                              <li>อาจมีค่าบริการ 5-15 บาทต่อครั้ง ขึ้นอยู่กับผู้บริการ</li>
                            </ul>

                          </div>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                </div>


                <!-- CHECK -->
                <div class="form__section" @click="paymentMethod = 'cheque'" v-if="isPaymentMethodEnable('cheque')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="cheque" value="cheque" />
                    <label class="form__label form__label--title" for="cheque">เช็คสั่งจ่าย</label><br />
                    <span class="form__label--note">มูลนิธิยุวพัฒน์ เพื่อโครงการร้อยพลังการศึกษา</span>
                    <span class="block--icon-bank">
                      <img class="" :src="$utils.svg(require('../assets/img/ic-cheque.svg'))" alt="เช็คสั่งจ่าย"  />
                    </span>
                  </div>
                </div>


                <!-- PAYPAL -->
                <div class="form__section" @click="paymentMethod = 'paypal'" v-if="isPaymentMethodEnable('paypal')">
                  <div class="form__item form__item--inline">
                    <input class="form__input" type="radio" name="payment_method" id="paypal" v-model="paymentMethod" value="paypal" />
                    <label class="form__label form__label--title" for="paypal">PayPal</label>
                    <img class="fl-right" :src="$utils.svg(require('../assets/img/ic-paypal.svg'))" alt="PayPal"  />
                  </div>
                </div>




              </div><!-- end form_wrapper -->

              <div class="block-primary block fixed fixed--bottom show-sm">
                <div class="">
                  <div class="form__item--inline mb-15 text-center">
                    <input class="form__text" type="checkbox" name="terms" id="terms1" v-model="acceptPolicy" />
                    <label class="form__label text-dark -font-light" for="terms1">ฉันได้อ่านและยอมรับ <a :href="$utils.getWpPath('terms')" target="_blank" @click.prevent="showTermsModal"><u>ข้อตกลงและเงื่อนไข</u></a></label>
                  </div>
                </div>
                <button class="btn btn--purple ma-0 btn-confirm" v-if="!isPaypal" @click="submit()" :disabled="!acceptPolicy">ยืนยันการบริจาค</button>
                <paypal-button ref="paypalButton1"
                               v-if="isPaypal"
                               v-show="paypalButtonReady"
                               id="paypal-button"
                               :payment="paypalPayment"
                               :onAuthorize="paypalOnAuthorize"
                               :onCancel="paypalOnCancel"
                               v-on:ready="paypalButtonReady = true"></paypal-button>
                <loader v-if="isPaypal" v-show="!paypalButtonReady"></loader>
                <div class="mt-3 text-muted-ss text-center" v-if="isTransfer">หลังจากโอนเงินแล้ว กรุณายืนยันการโอนเงินจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</div>
              </div>

            </form>
          </div>

          <div class="block-primary block radius b-payment mt-3">
            <h2 class="block__title mb-0">ใบเสร็จรับเงิน</h2>
            <template v-if="paymentMethod != 'thaiqr'">
              <div class="fs-sm mb-15 mt-2 text-dark">
                ระบบจะจัดส่งใบเสร็จรับเงินเป็นไฟล์ PDF ทางอีเมลภายหลัง
              </div>

              <ul class="nav nav-tabs">
                <li class="nav-item">
                  <a href="#" class="nav-link" :class="{active: taxInfoTab === 'person'}" @click.prevent="taxInfoTab = 'person'">บุคคลธรรมดา</a>
                </li>
                <li class="nav-item">
                  <a href="#" class="nav-link" :class="{active: taxInfoTab === 'legalPerson'}" @click.prevent="taxInfoTab = 'legalPerson'">นิติบุคคล</a>
                </li>
              </ul>
              <div class="border border-top-0 p-3 bg-white">
                <div class="row" v-if="taxInfoTab === 'person'">
                  <div class="col-md-6 col-sm-12">
                    <div class="form__item--block">
                      <label class="form__label" for="fullname">ชื่อ-นามสกุล</label>
                      <input class="form__text" type="text" name="fullname" id="fullname" v-model="fullname" :class="{ 'form__input--error': $v.isError('fullname') }" />
                      <div class="alert alert--error" v-show="$v.$errors.fullname.empty">กรุณากรอกข้อมูล</div>
                      <div class="fs-xs text-dark">กรุณากรอกด้วยชื่อ-นามสกุลจริงตามบัตรประชาชนเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี</div>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form__item--block">
                      <label class="form__label" for="taxid">เลขบัตรประชาชน</label>
                      <input class="form__text" type="text" name="taxid" id="taxid" v-model="taxId" :class="{ 'form__input--error': $v.isError('taxId') }" maxlength="17" v-mask="'#-####-#####-##-#'" />
                      <div class="alert alert--error" v-show="$v.$errors.taxId.empty">กรุณากรอกเลขบัตรประชาชนเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี <span class="d-none">กรุณากรอกข้อมูลเป็นตัวเลขเท่านั้น ไม่ต้องใส่เว้นวรรคหรือขีดกลาง</span></div>
                      <div class="alert alert--error" v-show="$v.$errors.taxId.invalid">เลขบัตรประชาชนต้องเป็นตัวเลข 13 หลัก<span class="d-none"><br />ไม่ต้องใส่เว้นวรรคหรือขีดกลาง</span></div>
                      <div class="alert alert--error" v-show="$v.$errors.taxId.taxIdFormatInvalid">รูปแบบเลขบัตรประชาชนไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง</div>
                    </div>
                  </div>
                </div>

                <div class="row" v-if="taxInfoTab === 'legalPerson'">
                  <div class="col-md-6 col-sm-12">
                    <div class="form__item--block">
                      <label class="form__label" for="fullname">ชื่อองค์กร</label>
                      <input class="form__text" type="text" name="fullname" id="fullname" v-model="fullname" :class="{ 'form__input--error': $v.isError('fullname') }" />
                      <div class="alert alert--error" v-show="$v.$errors.fullname.empty">กรุณากรอกข้อมูล</div>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form__item--block">
                      <label class="form__label" for="taxid">เลขประจำตัวผู้เสียภาษี</label>
                      <input class="form__text" type="text" name="taxid" id="taxid" v-model="taxId" :class="{ 'form__input--error': $v.isError('taxId') }" maxlength="17" v-mask="'#-####-#####-##-#'" />
                      <div class="alert alert--error" v-show="$v.$errors.taxId.empty">กรุณากรอกเลขประจำตัวผู้เสียภาษีเพื่อสิทธิประโยชน์ในการลดหย่อนภาษี <span class="d-none">ไม่ต้องใส่เว้นวรรคหรือขีดกลาง</span></div>
                      <div class="alert alert--error" v-show="$v.$errors.taxId.invalid">เลขประจำตัวผู้เสียภาษีต้องเป็นตัวเลข 13 หลัก<span class="d-none"><br />ไม่ต้องใส่เว้นวรรคหรือขีดกลาง</span></div>
                      <div class="alert alert--error" v-show="$v.$errors.taxId.taxIdFormatInvalid">รูปแบบเลขประจำตัวผู้เสียภาษีไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง</div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form__item--block">
                      <label for="taxAddress" class="form__label">ที่อยู่</label>
                      <textarea id="taxAddress" class="form__textarea" v-model="receiptAddress"></textarea>
                      <div class="alert alert--error" v-show="$v.$errors.receiptAddress.empty">กรุณากรอกข้อมูล</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="mt-3">
                * การบริจาคผ่าน QR code ในโครงการ e-Donation ชื่อ-นามสกุลบนใบเสร็จรับเงินจะเป็นชื่อเจ้าของบัญชี
                Mobile banking และข้อมูลบนใบเสร็จรับเงินของคุณจะถูกจัดส่งไปที่กรมสรรพากรอัตโนมัติ
              </div>
            </template>
          </div>

          <!-- <div class="block block-primary shadow show-sm">
            <div class="summary__row fs-sm">
              <span>หากท่านใดยังไม่ได้รับอีเมลการบริจาคภายใน 30 นาที ขอรบกวนลูกค้าส่งหมายเลขการบริจาคมายังอีเมล <a :href="'mailto:'+$config.WEBSITE_EMAIL">{{ $config.WEBSITE_EMAIL }}</a> นี้ด้วยค่ะ ทางเราจะดำเนินการตรวจสอบข้อมูลและแจ้งผลกลับไป ขอบคุณค่ะ</span>
            </div>
          </div> -->
        </div>

        <div class="sidebar-container hide-sm">
          <div class="sidebar" v-sticky="{top: 10, triggerTop: 'auto', triggerBottom: 70, bottom: -90}">
            <div class="block-border radius">
              <div class="summary__row--lg" v-for="cart in $store.state.cart">
                <div class="sidebar__title small">{{ $store.state.donateType === 'monthly' ? 'บริจาครายเดือนให้กับ' : 'บริจาคให้กับ' }}</div>
                <div class="summary__label">{{ cart.product.name }}</div>
                <div class="summary__value">{{ cart.product.price | comma }} <span class="txt-normal">บาท</span></div>
              </div>
              <div class="summary__row summary__row--lg" v-if="$store.state.cart.length > 1">
                <div class="summary__label"></div>
                <div class="summary__value">{{ $utils.getCartGrandTotalPrice() | comma }} ฿</div>
              </div>
              <div class="pt-15 block bg-gray border-bottom-radius">
                <div class="form__item form__item--inline">
                  <input class="form__input" type="checkbox" name="terms" id="terms2" v-model="acceptPolicy" />
                  <label class="form__label text-dark" for="terms2">ฉันได้อ่านและยอมรับ <a :href="$utils.getWpPath('terms')" target="_blank" @click.prevent="showTermsModal"><u>ข้อตกลงและเงื่อนไข</u></a></label>
                  <p class="text-muted-ss text-dark">ข้อมูลเกี่ยวกับการชำระเงินจะถูกเก็บรักษาภายใต้ความปลอดภัยของระบบ</p>
                </div>
                <button class="btn btn--purple ma-0 btn-confirm" v-if="!isPaypal" @click="submit()" :disabled="!acceptPolicy">ยืนยันการบริจาค</button>
                <paypal-button ref="paypalButton2"
                               v-if="isPaypal"
                               v-show="paypalButtonReady"
                               id="paypal-button2"
                               :payment="paypalPayment"
                               :onAuthorize="paypalOnAuthorize"
                               :onCancel="paypalOnCancel"
                               v-on:ready="paypalButtonReady = true"></paypal-button>
                <loader v-if="isPaypal" v-show="!paypalButtonReady"></loader>

                <div class="text-muted text-center pd-15 mt-15" v-if="isTransfer">หลังจากโอนเงินแล้ว กรุณายืนยันการโอนเงินจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</div>

              </div>
            </div>
            <!--<div class="block block-primary shadow">
              <div class="summary__row fs-sm">
                <span>หากลูกค้าท่านใดที่ยังไม่ได้รับอีเมลการสั่งซื้อสินค้าภายใน 30 นาที ขอรบกวนลูกค้าส่งหมายเลขคำสั่งซื้อมายังอีเมล <a :href="'mailto:'+$config.WEBSITE_EMAIL">{{ $config.WEBSITE_EMAIL }}</a> นี้ด้วยค่ะ ทางเราจะดำเนินการตรวจสอบข้อมูลและแจ้งผลกลับไป ขอบคุณค่ะ</span>
              </div>
            </div>-->
          </div>

          <div class="sidebar sidebar-ghost"></div>
        </div>
      </div>
    </div>

    <div class="container block-primary block shadow radius empty-cart" v-if="$utils.isCartEmpty()">
      คุณยังไม่ได้เลือกรายการบริจาค
      <router-link :to="{ name: 'products_list' }">เลือกดูรายการของเรา</router-link>
    </div>

    <form ref="form2c2p" :action="form2c2p.paymentUrl" method="POST">
      <input type="hidden" name="version" :value="form2c2p.version">
      <input type="hidden" name="merchant_id" :value="form2c2p.merchant_id">
      <input type="hidden" name="payment_description" :value="form2c2p.payment_description">
      <input type="hidden" name="order_id" :value="form2c2p.order_id">
      <!--<input type="hidden" name="invoice_no" :value="form2c2p.payment_description">-->
      <input type="hidden" name="currency" :value="form2c2p.currency">
      <input type="hidden" name="amount" :value="form2c2p.amount">
      <input type="hidden" name="result_url_1" :value="form2c2p.resultUrl">
      <input type="hidden" name="result_url_2" :value="form2c2p.backendReturnUrl">
      <input type="hidden" name="payment_option" :value="form2c2p.paymentOption">
      <input type="hidden" name="customer_email" :value="email">
      <input type="hidden" name="payment_expiry" :value="form2c2p.paymentExpiry">
      <input type="hidden" name="default_lang" value="th">
      <div v-if="form2c2p.recurring == 'Y' || form2c2p.recurring == 'M'">
        <input type="hidden" name="recurring" :value="form2c2p.recurring">
        <input type="hidden" name="charge_on_date" :value="form2c2p.chargeOnDate" v-if="form2c2p.chargeOnDate != ''">
        <input type="hidden" name="charge_next_date" :value="form2c2p.chargeNextDate" v-if="form2c2p.chargeNextDate != ''">
        <input type="hidden" name="allow_accumulate" :value="form2c2p.allowAccumulate">
        <input type="hidden" name="max_accumulate_amount" :value="form2c2p.maxAccumulateAmount" v-if="form2c2p.allowAccumulate == 'Y'">
        <input type="hidden" name="order_prefix" :value="form2c2p.orderPrefix">
        <input type="hidden" name="recurring_amount" :value="form2c2p.recurringAmount">
        <input type="hidden" name="recurring_count" :value="form2c2p.recurringCount">
        <input type="hidden" name="recurring_interval" :value="form2c2p.recurringInterval || 0" v-if="form2c2p.recurringInterval > 0">
        <input type="hidden" name="user_defined_1" :value="form2c2p.userDefined1 || ''">
      </div>
      <input type="hidden" name="hash_value" :value="form2c2p.hash_value">
    </form>

    <form ref="formTMB" :action="formTMB.paymentUrl" method="POST">
      <input type="hidden" name="orderRef" :value="formTMB.orderRef">
      <input type="hidden" name="amount" :value="formTMB.amount.toFixed(2)">
      <input type="hidden" name="currCode" :value="formTMB.currCode">
      <input type="hidden" name="merchantId" :value="formTMB.merchantId">
      <input type="hidden" name="cancelUrl" :value="formTMB.cancelUrl">
      <input type="hidden" name="failUrl" :value="formTMB.failUrl">
      <input type="hidden" name="successUrl" :value="formTMB.successUrl">
      <input type="hidden" name="payType" :value="formTMB.payType">
      <input type="hidden" name="payMethod" :value="formTMB.payMethod">
      <input type="hidden" name="lang" :value="formTMB.lang">
      <input type="hidden" name="remark" :value="formTMB.remark">
      <input type="hidden" name="orderRef1" :value="formTMB.orderRef1">
      <input type="hidden" name="orderRef2" :value="formTMB.orderRef2">
      <input type="hidden" name="orderRef3" :value="formTMB.orderRef3">
      <input type="hidden" name="orderRef4" :value="formTMB.orderRef4">
      <input type="hidden" name="orderRef5" :value="formTMB.orderRef5">
      <!-- schedule -->
      <template v-if="$store.state.donateType === 'monthly'">
        <input type="hidden" name="appId" :value="formTMB.appId">
        <input type="hidden" name="nSch" :value="formTMB.nSch">
        <input type="hidden" name="schType" :value="formTMB.schType">
        <input type="hidden" name="sDay" :value="formTMB.sDay">
        <input type="hidden" name="sMonth" :value="formTMB.sMonth">
        <input type="hidden" name="sYear" :value="formTMB.sYear">
        <input type="hidden" name="eDay" :value="formTMB.eDay">
        <input type="hidden" name="eMonth" :value="formTMB.eMonth">
        <input type="hidden" name="eYear" :value="formTMB.eYear">
        <input type="hidden" name="name" :value="formTMB.name">
        <input type="hidden" name="email" :value="formTMB.email">
        <input type="hidden" name="schStatus" :value="formTMB.schStatus">
        <input type="hidden" name="remark" :value="formTMB.remark">
      </template>
    </form>
  </div>
</template>

<script>
  import Vue from 'vue'
  import PaymentSummary from './PaymentSummary.vue'
  import CartSummary from './CartSummary.vue'
  import Loader from './Loader.vue'
  import AddressForm from './AddressForm.vue'
  import { INVOICE_STATUSES, INVOICE_SUBSTATUSES } from '../utils'
  require('../omise')
  const { isMobile } = require('is-mobile')
  import VueMask from 'v-mask'
  Vue.use(VueMask)

  import $ from 'jquery'
  import 'bootstrap/js/dist/modal'

  import ThaiQRBanner from '../assets/img/thaiqr_banner.png'
  import DonateStepBar from '@/components/DonateStepBar'
  const getThaiQRHtmlDesktop = (dataUri) => (`
<div class="thaiqr-instruction p-1" style="max-height: 80vh;overflow-y:scroll;">
    <div style="text-align:center;">
        <div class="mb-2">กรุณาทำรายการภายใน 30 นาที</div>
        <div><img src="${ThaiQRBanner}" height="70px" alt=""></div>
        <img src="${dataUri}" />
    </div>
    <div class="mt-3">
        <h4>ชื่อบัญชี กสศ. เงินบริจาค</h4>
        <div class="border rounded p-3" style="background-color:#eee;">
          <p class=" text-left"><strong>ขั้นตอนการบริจาคเงินโดยใช้ QR Code ผ่าน Mobile Banking</strong></p>
            <ol class="mb-0">
                <li>Login Mobile Banking</li>
                <li>เลือกเมนู Scan QR</li>
                <li>ใช้โทรศัพท์มือถือScan QR Code ที่ปรากฎบนหน้าจอนี้</li>
                <li>ตรวจสอบชื่อบัญชีว่าตรงกับชื่อบัญชีข้างต้นหรือไม่</li>
                <li>เมื่อทำรายการบน Mobile Banking เรียบร้อย ระบบจะตรวจสอบข้อมูลและส่ง Email เพื่อยืนยันการบริจาคให้ในภายหลัง</li>
            </ol>
        </div>
    </div>
</div>
`)
  const getThaiQRHtmlMobile = (dataUri) => (`
<div class="thaiqr-instruction p-1" style="max-height: 80vh;overflow-y:scroll;">
    <div style="text-align:center;">
        <div class="mb-2">กรุณาทำรายการภายใน 30 นาที</div>
        <div><img src="${ThaiQRBanner}" height="70px" alt=""></div>
        <img src="${dataUri}" />
    </div>
    <div class="mt-3">
        <h4>ชื่อบัญชี กสศ. เงินบริจาค</h4>
        <div class="border rounded p-3" style="background-color:#eee;">
          <p class=" text-left"><strong>ขั้นตอนการบริจาคเงินโดยใช้ QR Code ผ่าน Mobile Banking</strong></p>
            <ol class="mb-0">
                <li>Capture ภาพ QR Code ที่ปรากฎบนหน้าจอนี้</li>
                <li>Log-in Mobile Banking</li>
                <li>เลือกเมนู Scan QR Code</li>
                <li>กดปุ่ม “เลือกรูปภาพ” เพื่ออัปโหลดรูป QR Code ที่ Capture ไว้</li>
                <li>ตรวจสอบชื่อบัญชีว่าตรงกับชื่อบัญชีข้างต้นหรือไม่</li>
                <li>เมื่อทำรายการบน Mobile Banking เรียบร้อย ระบบจะตรวจสอบข้อมูลและส่ง Email เพื่อยืนยันการบริจาคให้ในภายหลัง</li>
            </ol>
        </div>
    </div>
</div>
`)

  const getThaiQRHtml = (dataUri) => {
    if (isMobile()) {
      return getThaiQRHtmlMobile(dataUri)
    }
    return getThaiQRHtmlDesktop(dataUri)
  }

  export default {
    components: {
      DonateStepBar,
      AddressForm,
      Loader,
      PaymentSummary,
      CartSummary,
      VueMask
    },
    name: 'Payment',
    created () {
      window.Omise.setPublicKey(Vue.config.OMISE_KEY)

      this.$store.dispatch('initCheckoutInfo')
      this.$store.dispatch('initDonateType')

      if (this.$utils.isCartEmpty()) {
        this.$router.push('/' + Vue.config.MAIN_PRODUCT_SKU)
        return
      }

      // const dependOn = {
      //   field: 'paymentMethod',
      //   value: 'credit_card'
      // }
      this.$utils.gaTrackCheckout()
      this.$utils.fbTrackInitiateCheckout()

      const dependOnNeedReceipt = {
        field: 'paymentMethod',
        not: 'thaiqr'
      }
      const dependOnLegalPerson = {
        field: 'taxInfoTab',
        value: 'legalPerson'
      }

      this.$v = this.$validator.init(this, {
        email: { checkEmpty: true, checkEmail: true, checkFacebookEmail: true },
        phone: { checkEmpty: true, checkPhone: true },
        // firstName: { checkEmpty: true, dependOn: depenOnNeedReceipt },
        // lastName: { checkEmpty: true, dependOn: depenOnNeedReceipt },
        fullname: { checkEmpty: true, dependOn: dependOnNeedReceipt },
        taxId: { checkEmpty: true, checkTaxId: true, checkTaxIdFormat: true, dependOn: dependOnNeedReceipt },
        receiptAddress: { checkEmpty: true, dependOn: [dependOnNeedReceipt, dependOnLegalPerson] },
        // receiptProvince: { checkEmpty: true, checkProvince: true, dependOn: dependOnNeedReceipt },
        // receiptPostalCode: { checkEmpty: true, checkPostcode: true, dependOn: dependOnNeedReceipt },
        paymentMethod: { checkEmpty: true, checkAllowedValues: Vue.config.AVAILABLE_PAYMENT_METHOD }
        // ccNumber: { checkEmpty: true, checkCreditCardNumber: true, dependOn: dependOn },
        // ccHolderName: { checkEmpty: true, dependOn: dependOn },
        // ccExpired: { checkEmpty: true, checkCreditCardExpired: true, dependOn: dependOn },
        // ccCVV: { checkEmpty: true, checkCreditCardCVV: true, dependOn: dependOn },
        // internetBankingOffsite: { checkEmpty: true, dependOn: { field: 'paymentMethod', value: 'internet_banking' } }
      })
    },
    data () {
      const backUrl = window.location.origin + window.location.pathname
      return {
        currentOrderId: '',
        invoiceCreated: false,

        submitting: false,
        formReady: false,
        showEmailForm: false,
        showAddressForm: false,
        acceptPolicy: false,
        email: '',
        firstName: '',
        lastName: '',
        taxInfoTab: 'person',
        fullname: '',
        taxId: '',
        telNo: '',
        phone: '',
        receiptAddress: '',
        receiptProvince: '',
        receiptPostalCode: '',
        needReceipt: true,
        needReceiptShipping: false,
        confirmThaiEmail: false,
        paymentMethod: '',
        ccNumber: '',
        ccHolderName: '',
        ccExpired: '',
        ccCVV: '',
        internetBankingOffsite: '',
        omiseToken: '',
        paypalButtonReady: false,
        paypalResolve: null,
        paypalReject: null,
        formValid: false,
        $v: null,
        form2c2p: {},
        invoiceSubmissionPromise: null,
        qrCodeDataURI: '',
        isTermsModalVisible: false,
        formTMB: {
          paymentUrl: Vue.config.TMB_API_URL + '/TMBPayment/eng/payment/payForm.jsp',
          orderRef: '',
          amount: 0,
          currCode: '764',
          lang: 'T',
          cancelUrl: (backUrl + '?tmbcancel=t').replace(/\?\?/, '?'),
          failUrl: (backUrl + '?tmbcancel=t').replace(/\?\?/, '?'),
          successUrl: (backUrl + '?tmbsuccess=t').replace(/\?\?/, '?'),
          merchantId: Vue.config.TMB_MERCHANT_ID,
          payType: 'N',
          payMethod: 'CC',
          orderRef1: '',
          orderRef2: '',
          orderRef3: '',
          orderRef4: '',
          orderRef5: '',
          // templateId: 1,
          remark: '-',
          // schedule payment
          appId: 'SP',
          nSch: '',
          schType: '',
          sDay: '',
          sMonth: '',
          sYear: '',
          eDay: '',
          eMonth: '',
          eYear: '',
          name: '',
          email: '',
          schStatus: ''
        }
      }
    },
    mounted () {
      // prevent chrome autofill
      this.email = this.$utils.cleanEmailInvisibleChars(this.shippingEmail)
      if (this.email.match(/tel.(\d+)@tcfe.or.th/g)) {
        this.email = ''
      }
      if (this.$store.state.user) {
        this.phone = this.$store.state.user.telNo
        this.firstName = this.$store.state.user.firstName
        this.lastName = this.$store.state.user.lastName
        const fullnames = []
        if (this.firstName) {
          fullnames.push(this.firstName)
        }
        if (this.lastName) {
          fullnames.push(this.lastName)
        }
        this.fullname = fullnames.join(' ')
      }

      this.$store.dispatch('initCheckoutInfo')
      const info = this.$store.state.checkoutInfo
      if (info) {
        if (info.email) {
          this.email = info.email
        }
        if (info.phone) {
          this.phone = info.phone
        }
        if (info.firstName) {
          this.firstName = info.firstName
        }
        if (info.lastName) {
          this.lastName = info.lastName
        }
        // if (info.fullname) {
        //   this.fullname = info.fullname
        // }
        // if (info.taxId) {
        //   this.taxId = info.taxId
        // }
        // if (info.needReceiptShipping) {
        //   this.needReceiptShipping = info.needReceiptShipping
        // }
        // if (info.receiptAddress) {
        //   this.receiptAddress = info.receiptAddress
        // }
        // if (info.receiptProvince) {
        //   this.receiptProvince = info.receiptProvince
        // }
        // if (info.receiptPostalCode) {
        //   this.receiptPostalCode = info.receiptPostalCode
        // }
      }

      setTimeout(() => {
        this.formReady = true
      }, 500)

      if (!this.$store.state.user) {
        this.editEmail()
      }
    },
    computed: {
      shippingEmail () {
        const user = this.$store.state.user
        if (user) {
          return (user.shippingContact && user.shippingContact.email) || this.$store.state.user.email
        } else {
          return ''
        }
      },
      isFacebookEmail () {
        return this.email.match(/@facebook.com$/)
      },
      isEmptyAddress () {
        return this.$utils.isEmptyAddress()
      },
      emailFormVisible () {
        this.showEmailForm = this.showEmailForm || this.isFacebookEmail
        return this.showEmailForm || !this.email
      },
      addressFormVisible () {
        return this.isEmptyAddress || this.showAddressForm
      },
      address () {
        return `${this.info.address || ''}`
      },
      city () {
        return `${this.$utils.provincesMap[this.info.province] || ''} ${this.info.postalCode || ''}`
      },
      province () {
        return this.info.province || ''
      },
      postcode () {
        return this.info.postalCode || ''
      },
      fullAddress () {
        let items = []
        if (this.address) {
          items.push(this.address)
        }
        if (this.city) {
          items.push(this.city)
        }
        return items.join(' ')
      },
      receiptCity () {
        return `${this.$utils.provincesMap[this.receiptProvince] || ''} ${this.receiptPostalCode || ''}`
      },
      fullReceiptAddress () {
        let items = []
        if (this.receiptAddress) {
          items.push(this.receiptAddress)
        }
        if (this.receiptCity) {
          items.push(this.receiptCity)
        }
        return items.join(' ')
      },
      useCreditCard () {
        return this._useCreditCard()
      },
      user () {
        return this.$store.state.user
      },
      token () {
        return this.$store.state.token
      },
      info () {
        return this.$store.state.checkoutInfo
      },
      isCreditCard () {
        return this.paymentMethod === 'credit_card'
      },
      isInternetBanking () {
        return this.paymentMethod === 'internet_banking'
      },
      is2C2P123 () {
        return this.paymentMethod === '2c2p:123'
      },
      isLinePay () {
        return this.paymentMethod === 'line_pay'
      },
      isPaypal () {
        return this.paymentMethod === 'paypal'
      },
      isTransfer () {
        return this.paymentMethod === 'bank_transfer'
      },
      isThaiQR () {
        return this.paymentMethod === 'thaiqr'
      },
      defaultPaymentPayload () {
        let offlineShippingDetail = this.$utils.getOfflineShippingInfo() + ' ' + this.$utils.getOfflineShippingDetail()
        offlineShippingDetail = offlineShippingDetail.trim()
        let data = {
          client_id: this.$store.state.clientId,
          domain: this.$config.DOMAIN,
          email: this.email,
          fullname: (this.paymentMethod !== 'thaiqr' && this.needReceipt) ? this.fullname : '',
          phone_number: this.phone,
          request_receipt: this.needReceipt,
          receipt_fullname: (this.paymentMethod !== 'thaiqr' && this.needReceipt) ? this.fullname : '',
          receipt_address: this.taxInfoTab === 'legalPerson' ? this.receiptAddress : '',
          request_receipt_shipping: false,
          receipt_tax_id: this.taxId.replace(/[^0-9]/g, ''),
          invoice_product_list: this.$store.state.cart.map(item => {
            return {
              product_sku: item.product.sku,
              product_sub_sku: this.$utils.getProductSubSku(item.product, item.attributes),
              product_quantity: item.quantity,
              product_price: item.product.price,
              product_data: JSON.stringify(item.attributes.info || {})
            }
          }),
          offline_shipping: true,
          offline_shipping_detail: offlineShippingDetail
        }

        return data
      }
    },
    methods: {
      onStep (idx) {
        if (!idx) {
          const sku = this.$store.state.cart[0].product.sku
          this.$router.push(`/${sku}`)
        }
      },
      isPaymentMethodEnable (value) {
        if (value === 'credit_card' && window.location.search.match(/force_credit_card=20190823001/)) {
          return true
        }
        if (this.$store.state.donateType === 'monthly') {
          return Vue.config.AVAILABLE_MONTHLY_PAYMENT_METHOD.includes(value)
        } else {
          return Vue.config.AVAILABLE_PAYMENT_METHOD.includes(value)
        }
      },
      _useCreditCard () {
        return this.paymentMethod === 'credit_card'
      },
      editEmail () {
        this.showEmailForm = true
      },
      editAddress () {
        this.showAddressForm = true
      },
      hasThaiCharacters (value) {
        return value.match(/[\u0e01-\u0e5b]/)
      },
      addressSaved () {
        // TODO: do somethings?
      },
      closeModal () {
        this.$modal.hide()
      },
      showProgressModal (orderId) {
        let text = `กำลังดำเนินการ โปรดอย่าปิดหน้านี้จนกว่าจะทำการชำระเงินสำเร็จ`
        if (orderId) {
          text += ` <br>หมายเลขรายการ: <em>${orderId}</em>`
        }
        this.$modal.show({
          title: 'โปรดรอสักครู่',
          text: text,
          okButton: false,
          showLoader: true
        })
      },
      showErrorModal (message, ok, cancel) {
        let htmlMsg = ''
        if (message) {
          htmlMsg = ` <div class="payment-error-message mt-30"><strong>ข้อความจากระบบ:</strong><div class="-msg">${message}</div></div>`
        }

        const orderId = this.$store.state.orderId
        let orderMsg = ''
        if (orderId) {
          orderMsg = `หมายเลขรายการ: <em>${orderId}</em><br>`
        }

        this.$modal.show({
          title: 'ผิดพลาด',
          text: `${orderMsg}ไม่สามารถชำระเงินได้ กรุณาลองใหม่อีกครั้ง${htmlMsg}`,
          ok: ok,
          cancel: cancel
        })
        this.$utils.fbTrack('paymentError', this.totalPrice, { orderId: orderId, cart: this.$store.state.cart })
      },
      showTermsModal () {
        if (!this.$refs.termsModal) { return }
        $(this.$refs.termsModal).modal('show')
      },
      hideTermsModal () {
        if (!this.$refs.termsModal) { return }
        $(this.$refs.termsModal).modal('hide')
      },
      getOmiseToken (cardObject) {
        return new Promise((resolve, reject) => {
          window.Omise.createToken('card', cardObject, (statusCode, response) => {
            if (statusCode === 200) {
              resolve(response.id)
            } else {
              reject(response)
            }
          })
        })
      },
      async donePayment (orderId) {
        this.submitting = false
        this.invoiceCreated = false
        this.currentOrderId = ''
        if (!orderId) {
          orderId = this.$store.state.orderId
        }
        const publicOrderId = this.$store.state.publicOrderId || orderId
        this.closeModal()
        // const sku = this.$store.state.cart[0].product.sku

        // track analytics
        const cartItems = this.$store.state.cart.map(it => Object.assign({}, it))

        this.$modal.show({
          title: '',
          okButton: false,
          showLoader: true
        })
        await this.$utils.safeTrackPurchase(orderId, this.$utils.getCartGrandTotalPrice(), this.paymentMethod, cartItems)

        this.$store.dispatch('clearCart')
          .then(() => {
            if (['bank_transfer', 'cheque'].indexOf(this.paymentMethod) > -1) {
              this.$modal.hide()
              this.$router.push(`/thank-you/${publicOrderId}`)
            // } else if (sku !== Vue.config.MAIN_PRODUCT_SKU) {
            //   window.document.location = Vue.config.WP_CAMPAIGN_URL.replace(/%sku%/, sku)
            } else {
              window.document.location = Vue.config.MAIN_WEBSITE_URL + `/thankyou/?orderId=${publicOrderId}`
            }
          })
      },
      handlePaymentResult (event) {
        const data = JSON.parse(event.data)
        console.log('handlePaymentResult', data)

        if (data.type === 'userFeedback') {
          this.$store.state.ws.removeEventListener('message', this.handlePaymentResult)
          this.submitting = false

          const payload = data.payload
          this.invoiceSubmissionPromise.then(() => {
            if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
              if (payload.success === true) {
                switch (payload.payment_method) {
                  case 'internet_banking':
                    this.handlePaymentResultInternetBanking(payload)
                    break
                  case 'line_pay':
                    this.handlePaymentResultLinePay(payload)
                    break
                  default:
                    // backward compatibility
                    this.handlePaymentResultInternetBanking(payload)
                }
              } else {
                this.showErrorModal(payload.message)
                this.$store.dispatch('resetPayment')
              }

              this.submitting = false
            }
          })
        }
      },
      handlePaymentResultInternetBankingOmise (payload) {
        if (payload.data && payload.data.authorize_uri) {
          window.location.href = payload.data.authorize_uri
        } else if (payload.data && payload.data.status === 'successful') {
          this.donePayment()
        } else {
          this.showErrorModal(payload.message)
          this.$store.dispatch('resetPayment')
        }
      },
      handlePaymentResultInternetBanking2c2p (payload) {
        // TODO: noomz here
      },
      handlePaymentResultInternetBanking (payload) {
        if (payload.payment_provider === 'omise') {
          this.handlePaymentResultInternetBankingOmise(payload)
        } else if (payload.payment_provider === '2c2p') {
          this.handlePaymentResultInternetBanking2c2p(payload)
        } else {
          // backward compatibility
          this.handlePaymentResultInternetBankingOmise(payload)
        }
      },
      handlePaymentResultLinePay (payload) {
        console.log('payload.data', payload.data)
        if (payload.data && payload.data.info && payload.data.info.paymentUrl && payload.data.info.paymentUrl.web) {
          window.location.href = payload.data.info.paymentUrl.web
        } else if (payload.data && payload.data.status === 'successful') {
          // TODO: handle
          this.donePayment()
        } else {
          this.showErrorModal(payload.message)
          this.$store.dispatch('resetPayment')
        }
      },
      charge (extraPayload) {
        this.$store.state.ws.addEventListener('message', this.handlePaymentResult)

        let resolver = null
        this.invoiceSubmissionPromise = new Promise((resolve) => {
          resolver = resolve
        })

        let payload = this.defaultPaymentPayload

        Object.assign(payload, extraPayload)

        let url = 'invoices'
        if (this.$store.state.donateType === 'monthly') {
          let donateType = 'monthly'
          if (this.$store.state.forceDaily) {
            donateType = 'daily'
          }
          url += `?donateType=${donateType}&planCode=` + Vue.config.DEFAULT_PLAN_CODE
        }

        this.$http.post(url, payload)
          .then(resp => {
            this.$store.dispatch('setOrderId', { orderId: resp.body.order_id, publicOrderId: resp.body.public_order_id }).then(() => {
              this.showProgressModal(this.$store.state.orderId)
              resolver()
            })
            this.submitting = false

            // fallback when timeout on reply from omise + pubsub
            const t = setInterval(() => {
              const timeDiff = (new Date()) - this.$store.state.orderIdTimestamp
              if (this.$store.state.orderId && timeDiff > Vue.config.PAYMENT_TIMEOUT) {
                // cancel handleOmisePaymentResult
                this.$store.state.ws.removeEventListener('message', this.handlePaymentResult)
                if (timeDiff > Vue.config.PAYMENT_RECHECK_TIMEOUT) {
                  clearInterval(t)
                  this.$store.dispatch('resetPayment')
                  this.showErrorModal()
                  return
                }
                // get order status
                this.$utils.getInvoice(this.$store.state.publicOrderId || this.$store.state.orderId)
                  .then(invoice => {
                    if (invoice.status === INVOICE_STATUSES.PAID) {
                      clearInterval(t)
                      this.donePayment()
                      return
                    }

                    if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                      clearInterval(t)
                      this.$store.dispatch('resetPayment')
                      this.showErrorModal()
                    }
                  })
                  .catch(err => {
                    console.log(err)
                  })
              }
            }, Vue.config.PAYMENT_RECHECK_INTERVAL)
          })
          .catch(err => {
            console.log(err)
            resolver()
            if (err.body.invalidItems) {
              this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
                this.$utils.scrollToFirstErrors()
              })
            } else if (err.body.message.match(/invalid/i)) {
              this.showErrorModal(err.body.message, () => {
                this.$utils.scrollToFirstErrors()
              })
            } else {
              this.showErrorModal()
            }
            this.$store.dispatch('resetPayment')
            this.submitting = false
          })
      },
      async handleTMBPaymentResult (payload) {
        console.info('[TMB] get payload ', payload)
        try {
          const resp = JSON.parse(payload.data)
          if (resp.type !== 'userFeedback') {
            return
          }

          const data = resp.payload
          await this.$utils.ensure(this, 'invoiceCreated')
          if (data.order_id !== this.$store.state.orderId) {
            return
          }

          this.formTMB.orderRef = data.data.orderRef
          this.formTMB.orderRef1 = data.data.orderRef1
          this.formTMB.orderRef2 = this.email
          // this.formTMB.orderRef3 = this.fullname
          this.formTMB.orderRef4 = this.phone_number
          this.formTMB.amount = data.data.amount
          this.formTMB.appId = data.data.appId
          this.formTMB.nSch = data.data.nSch
          this.formTMB.schType = data.data.schType
          this.formTMB.sDay = data.data.sDay
          this.formTMB.sMonth = data.data.sMonth
          this.formTMB.sYear = data.data.sYear
          this.formTMB.eDay = ''
          this.formTMB.eMonth = ''
          this.formTMB.eYear = ''
          this.formTMB.name = data.data.name
          this.formTMB.email = this.email
          this.formTMB.schStatus = data.data.schStatus
          this.formTMB.remark = data.data.remark

          this.$nextTick(() => {
            setTimeout(() => {
              this.$refs.formTMB.submit()
            }, 1000)
          })
        } catch (e) {
          this.showErrorModal(e)
          this.$store.dispatch('resetPayment')
        }
      },
      async handleThaiQRPaymentResult (payload) {
        console.info('[ThaiQR] get payload ', payload)
        try {
          let data = JSON.parse(payload.data)
          if (data.type !== 'userFeedback') {
            return
          }
          data = data.payload
          await this.$utils.ensure(this, 'invoiceCreated')
          if (data.order_id !== this.$store.state.orderId) {
            return
          }
          const total = this.$utils.getCartGrandTotalPrice()
          // this.$store.dispatch('resetPayment')
          this.$store.state.ws.removeEventListener('message', this.handleThaiQRPaymentResult)
          this.$store.state.ws.addEventListener('message', this.handleThaiQRPaymentSuccess)
          console.info('[ThaiQR] removed listener ', this.$store.state.orderId)
          this.$modal.show({
            title: `กรุณา Scan QR code เพื่อชำระเงิน ${this.$utils.formatMoney(total)} บาท`,
            text: getThaiQRHtml(data.data.qrCodeDataURI),
            okButton: false
          })
          const startAt = new Date()
          setTimeout(() => {
            const t = setInterval(async () => {
              // eslint-disable-next-line no-unused-vars
              const retrieve = (new Date()) - startAt > Vue.config.PAYMENT_TIMEOUT
              const inv = await this.$utils.getInvoice(this.$store.state.publicOrderId || this.$store.state.orderId, false)
              if (inv.status === INVOICE_STATUSES.PAID) {
                clearInterval(t)
                this.donePayment(data.order_id)
              }
            }, 5000)
          }, 5000)
        } catch (e) {
          console.log(e)
          this.showErrorModal(e)
          this.$store.dispatch('resetPayment')
        }
      },
      async payByThaiQR () {
        let payload = Object.assign({}, this.defaultPaymentPayload, {payment_method: 'thaiqr'})
        let url = 'invoices'

        this.submitting = true
        this.invoiceCreated = false
        this.$store.state.ws.addEventListener('message', this.handleThaiQRPaymentResult)
        console.info('[ThaiQR] started listener')

        try {
          const {body: inv} = await this.$http.post(url, payload)
          await this.$store.dispatch('setOrderId', { orderId: inv.order_id, publicOrderId: inv.public_order_id })
          this.invoiceCreated = true
          this.currentOrderId = inv.order_id

          this.showProgressModal(inv.order_id)

          const t = setInterval(async () => {
            const now = new Date()
            const timeDiff = now - this.$store.state.orderIdTimestamp
            if (this.$store.state.orderId && timeDiff > Vue.config.PAYMENT_TIMEOUT) {
              this.$store.state.ws.removeEventListener('message', this.handleThaiQRPaymentResult)
              console.info('[ThaiQR] removed listener ', this.$store.state.orderId)
              const invoice = await this.$utils.getInvoice(this.$store.state.publicOrderId || this.$store.state.orderId)

              const timeout = Vue.config.PAYMENT_TIMEOUT + Vue.config.PAYMENT_RECHECK_TIMEOUT
              if (timeDiff > timeout) {
                clearInterval(t)
                this.showErrorModal()
                this.$store.dispatch('resetPayment')
                return
              }

              if (invoice.status === INVOICE_STATUSES.WAIT_FOR_PAYMENT && invoice.substatus === INVOICE_SUBSTATUSES.PAYMENT_PENDING) {
                clearInterval(t)
                return
              }

              if (invoice.status === INVOICE_STATUSES.PAID) {
                clearInterval(t)
                this.donePayment()
                return
              }

              if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE && invoice.substatus !== INVOICE_SUBSTATUSES.PAYMENT_PENDING) {
                clearInterval(t)
                this.showErrorModal()
                this.$store.dispatch('resetPayment')
              }
            }
          }, Vue.config.PAYMENT_RECHECK_INTERVAL)
        } catch (e) {
          console.log(e)
          this.showErrorModal(e)
          this.$store.dispatch(('resetPayment'))
        }

        this.submitting = false
      },
      payByTMBCreditCard (extraPayload) {
        let payload = this.defaultPaymentPayload
        Object.assign(payload, extraPayload)

        let url = 'invoices'
        if (this.$store.state.donateType === 'monthly') {
          let donateType = 'monthly'
          if (this.$store.state.forceDaily) {
            donateType = 'daily'
          }
          url += `?donateType=${donateType}&planCode=` + Vue.config.DEFAULT_PLAN_CODE
        }

        this.$store.state.ws.addEventListener('message', this.handleTMBPaymentResult)
        console.log('[TMB] started listener ')

        this.$http.post(url, payload)
          .then(resp => {
            this.submitting = false

            const inv = resp.body

            this.$store.dispatch('setOrderId', { orderId: inv.order_id, publicOrderId: inv.public_order_id }).then(() => {
              this.invoiceCreated = true
              this.currentOrderId = inv.order_id

              this.showProgressModal(inv.order_id)

              const t = setInterval(() => {
                if (this.$store.state.orderId && (new Date()) - this.$store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT) {
                  this.$store.state.ws.removeEventListener('message', this.handlePaymentResult)
                  console.info('[TMB] removed listener ', this.$store.state.orderId)

                  // get order status
                  this.$utils.getInvoice(this.$store.state.publicOrderId || this.$store.state.orderId)
                    .then(invoice => {
                      if (invoice.status === INVOICE_STATUSES.WAIT_FOR_PAYMENT && invoice.substatus === INVOICE_SUBSTATUSES.PAYMENT_PENDING) {
                        this.handleTMBPaymentResult({
                          data: JSON.stringify({
                            type: 'userFeedback',
                            payload: {
                              order_id: this.$store.state.orderId
                            }
                          })
                        })
                      }
                      if (invoice.status === INVOICE_STATUSES.PAID) {
                        clearInterval(t)
                        this.donePayment()
                        return
                      }

                      if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                        clearInterval(t)
                        this.$store.dispatch('resetPayment')
                        this.showErrorModal()
                      }
                    })
                    .catch(err => {
                      console.log(err)
                    })
                }
              }, Vue.config.PAYMENT_RECHECK_INTERVAL)
            })
          })
          .catch(e => {
            console.log(e)
            this.showErrorModal()
            this.$store.dispatch('resetPayment')
            this.submitting = false
          })
      },
      async payByPaco () {
        let url = 'invoices'
        const donateType = this.$store.state.forceDaily ? 'daily' : 'monthly'
        url += `?donateType=${donateType}&planCode=` + Vue.config.DEFAULT_PLAN_CODE

        const payload = Object.assign({}, this.defaultPaymentPayload, {
          payment_method: 'credit_card'
        })

        try {
          const resp = await this.$http.post(url, payload)
          const inv = resp.body

          await this.$store.dispatch('setOrderId', { orderId: inv.order_id, publicOrderId: inv.public_order_id })

          if (inv.paco_payment_url) {
            window.location.href = inv.paco_payment_url
          } else {
            this.showErrorModal('ไม่สามารถเริ่มการชำระเงินได้')
          }
        } catch (e) {
          this.showErrorModal()
          this.$store.dispatch('resetPayment')
          this.submitting = false
        }
      },
      payByOmiseCreditCard () {
        const cardObject = {
          name: this.ccHolderName,
          number: this.ccNumber,
          expiration_month: this.ccExpired.split('/')[0],
          expiration_year: this.ccExpired.split('/')[1],
          security_code: this.ccCVV
        }

        this.getOmiseToken(cardObject)
          .then(token => {
            this.charge({
              payment_method: 'credit_card',
              payment_payload: token
            })
          })
          .catch(err => {
            console.log(err)
            this.$store.dispatch('setOrderId', null)
            this.showErrorModal(err.message)
            this.submitting = false
          })
      },
      payByOmiseInternetBanking () {
        this.charge({
          payment_method: 'internet_banking',
          payment_payload: this.internetBankingOffsite + '|' + window.location.href
        })
      },
      payBy2c2pInternetBanking () {
        this.payBy2c2p({
          payment_method: '2c2p:123',
          payment_payload: JSON.stringify({
            returnUrl: this.returnUrlFor2c2p()
          })
        })
      },
      returnUrlFor2c2p () {
        return Vue.http.options.root + 'postback/2c2p'
        // return window.location.href
      },
      handle2c2pPaymentResult (event) {
        const data = JSON.parse(event.data)
        console.log('handle2c2pPaymentResult', data)
        if (data.type === 'userFeedback') {
          this.$store.state.ws.removeEventListener('message', this.handle2c2pPaymentResult)
          this.submitting = false

          const payload = data.payload
          this.invoiceSubmissionPromise.then(() => {
            if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
              if (payload.success === true) {
                let d = payload.data
                this.form2c2p = {
                  version: d.version,
                  merchant_id: d.merchantId,
                  currency: 764,
                  hash_value: d.hashValue,
                  payment_description: this.$store.state.orderId,
                  order_id: d.shortOrderId,
                  amount: d.amount,
                  paymentOption: d.paymentOption,
                  resultUrl: this.returnUrlFor2c2p(),
                  backendReturnUrl: d.backendReturnUrl,
                  paymentUrl: d.paymentUrl,
                  paymentExpiry: d.paymentExpiry,
                  orderPrefix: d.orderPrefix,
                  allowAccumulate: d.allowAccumulate,
                  maxAccumulateAmount: d.maxAccumulateAmount,
                  recurring: d.recurring,
                  recurringAmount: d.recurringAmount,
                  recurringInterval: d.recurringInterval,
                  recurringCount: d.recurringCount || 0,
                  chargeNextDate: (d.chargeNextDate || '').trim(),
                  chargeOnDate: (d.chargeOnDate || '').trim(),
                  userDefined1: d.userDefined1,
                  userDefined2: d.userDefined2,
                  userDefined3: d.userDefined3,
                  userDefined4: d.userDefined4,
                  userDefined5: d.userDefined5
                }

                this.$forceUpdate()
                setTimeout(() => {
                  this.$refs.form2c2p.submit()
                }, 2000)
              } else {
                this.showErrorModal(payload.message)
                this.$store.dispatch('resetPayment')
              }

              this.submitting = false
            }
          })
        }
      },
      payBy2c2pCreditCard () {
        this.payBy2c2p({
          payment_method: 'credit_card',
          payment_payload: JSON.stringify({
            returnUrl: this.returnUrlFor2c2p()
          })
        })
      },
      payBy2c2p (extraPayload) {
        let payload = this.defaultPaymentPayload
        Object.assign(payload, extraPayload)

        this.$store.state.ws.addEventListener('message', this.handle2c2pPaymentResult)

        let resolver = null
        this.invoiceSubmissionPromise = new Promise((resolve) => {
          resolver = resolve
        })

        let url = 'invoices'
        if (this.$store.state.donateType === 'monthly') {
          url += '?donateType=monthly&planCode=' + Vue.config.DEFAULT_PLAN_CODE
        }

        this.$http.post(url, payload)
          .then(resp => {
            this.$store.dispatch('setOrderId', { orderId: resp.body.order_id, publicOrderId: resp.body.public_order_id }).then(() => {
              this.showProgressModal(this.$store.state.orderId)
              resolver()
            })
            this.submitting = false

            // fallback when timeout on reply from omise + pubsub
            const t = setInterval(() => {
              if (this.$store.state.orderId && (new Date()) - this.$store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT) {
                this.$store.state.ws.removeEventListener('message', this.handle2c2pPaymentResult)

                // get order status
                this.$utils.getInvoice(this.$store.state.publicOrderId || this.$store.state.orderId)
                  .then(invoice => {
                    if (invoice.status === INVOICE_STATUSES.PAID) {
                      clearInterval(t)
                      this.donePayment()
                      return
                    }

                    if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                      clearInterval(t)
                      this.$store.dispatch('resetPayment')
                      this.showErrorModal()
                    }
                  })
                  .catch(err => {
                    console.log(err)
                  })
              }
            }, Vue.config.PAYMENT_RECHECK_INTERVAL)
          })
          .catch(e => {
            console.log(e)
            resolver()
            this.showErrorModal()
            this.$store.dispatch('resetPayment')
            this.submitting = false
          })
      },
      payByTransfer () {
        let payload = this.defaultPaymentPayload
        payload.payment_method = 'bank_transfer'

        this.$http.post('invoices', payload)
          .then(resp => {
            this.$store.dispatch('setOrderId', { orderId: resp.body.order_id, publicOrderId: resp.body.public_order_id })
            this.submitting = false
            this.donePayment()
          })
          .catch(err => {
            console.log(err)
            if (err.body.invalidItems) {
              this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
                this.$utils.scrollToFirstErrors()
              })
            } else if (err.body.message.match(/invalid/i)) {
              this.showErrorModal(err.body.message, () => {
                this.$utils.scrollToFirstErrors()
              })
            } else {
              this.showErrorModal()
            }
            this.submitting = false
          })
      },
      payByCheque () {
        let payload = this.defaultPaymentPayload
        payload.payment_method = 'cheque'

        this.$http.post('invoices', payload)
          .then(resp => {
            this.$store.dispatch('setOrderId', { orderId: resp.body.order_id, publicOrderId: resp.body.public_order_id }).then(() => {
              this.submitting = false
              this.donePayment(resp.body.order_id)
            })
          })
          .catch(err => {
            console.log(err)
            if (err.body.invalidItems) {
              this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
                this.$utils.scrollToFirstErrors()
              })
            } else if (err.body.message.match(/invalid/i)) {
              this.showErrorModal(err.body.message, () => {
                this.$utils.scrollToFirstErrors()
              })
            } else {
              this.showErrorModal()
            }
            this.submitting = false
          })
      },
      payByPaypal () {
        // Nothing.
      },
      payByLinePay () {
        this.charge({
          payment_method: 'line_pay',
          payment_payload: 'request|' + window.location.href
        })
      },
      getStockInvalidItemsMessages (invalidItems) {
        if (!invalidItems) {
          return ''
        }

        let productsMap = {}
        for (let item of this.$store.state.cart) {
          productsMap[item.product.sku] = item.product.name
        }

        let itemMessages = []
        for (let item of invalidItems) {
          let skuParts = item.sku.split(':')
          itemMessages.push(`- ${productsMap[skuParts[0]]} (${skuParts[1].replace(/_/g, ' / ')})`)
        }
        return `มีจำนวนรายการคงคลังไม่เพียงพอสำหรับรายการต่อไปนี้<br>${itemMessages.join('<br>')}`
      },
      handlePaypalCreatePaymentResult (event) {
        const data = JSON.parse(event.data)

        if (data.type === 'userFeedback') {
          this.$store.state.ws.removeEventListener('message', this.handlePaypalCreatePaymentResult)
          const payload = data.payload
          if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
            if (payload.data && payload.data.state === 'created' && payload.success) {
              this.paypalResolve(payload.data.id)
            } else {
              this.submitting = false
              this.showErrorModal()
              this.paypalReject(new Error('Cannot create payment'))
            }
          }
        }
      },
      handlePaypalExecutePaymentResult (event) {
        const data = JSON.parse(event.data)

        if (data.type === 'userFeedback') {
          this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)
          const payload = data.payload
          if (payload.type === 'PaymentResult' && payload.order_id === this.$store.state.orderId) {
            if (payload.data && payload.data.state === 'approved' && payload.success) {
              this.paypalResolve()
              this.donePayment()
            } else {
              this.submitting = false
              this.showErrorModal()
              this.paypalReject(new Error('Cannot execute payment'))
            }
          }
        }
      },
      /*
      paypalPayment (data, actions) {
        // trigger for submit.
        if (!this.submit()) {
          return Promise.reject(new Error('Form is not validated'))
        }

        let payload = this.defaultPaymentPayload
        payload.payment_method = 'paypal'

        this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)
        this.$store.state.ws.addEventListener('message', this.handlePaypalCreatePaymentResult)

        return new paypal.Promise((resolve, reject) => {
          this.paypalResolve = resolve
          this.paypalReject = reject

          this.$http.post('invoices', payload)
            .then(resp => {
              console.log(resp)
              this.$store.dispatch('setOrderId', { orderId: resp.body.order_id, publicOrderId: resp.body.public_order_id }).then(() => {
                this.showProgressModal(this.$store.state.orderId)
              })
            })
            .catch(err => {
              console.log(err)
              this.submitting = false
              if (err.body.invalidItems) {
                this.showErrorModal(this.getStockInvalidItemsMessages(err.body.invalidItems), () => {
                  this.$utils.scrollToFirstErrors()
                })
              } else if (err.body.message.match(/invalid/i)) {
                this.showErrorModal(err.body.message, () => {
                  this.$utils.scrollToFirstErrors()
                })
              } else {
                this.showErrorModal()
              }
              reject(err)
            })
        })
      }, */
      paypalOnAuthorize (data, actions) {
        data = {
          client_id: this.$store.state.clientId,
          payment_id: data.paymentID,
          payer_id: data.payerID,
          order_id: this.$store.state.orderId
        }

        return new Promise((resolve, reject) => {
          this.paypalResolve = resolve
          this.paypalReject = reject

          this.$store.state.ws.removeEventListener('message', this.handlePaypalCreatePaymentResult)
          this.$store.state.ws.addEventListener('message', this.handlePaypalExecutePaymentResult)
          this.$store.dispatch('setPaypalPaymentId', data.payment_id)

          this.$http.post('payments/paypal/execute', data)
            .then(resp => {
              console.log(resp)

              // fallback when timeout on reply from paypal + pubsub
              const t = setInterval(() => {
                if (this.$store.state.orderId && (new Date()) - this.$store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT) {
                  // cancel handleOmisePaymentResult
                  this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)

                  // get order status
                  this.$utils.getInvoice(this.$store.state.publicOrderId || this.$store.state.orderId)
                    .then(invoice => {
                      if (invoice.status === INVOICE_STATUSES.PAID) {
                        clearInterval(t)
                        this.donePayment()
                        return
                      }

                      if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                        clearInterval(t)
                        this.showErrorModal()
                      }
                    })
                    .catch(err => {
                      console.log(err)
                    })
                }
              }, Vue.config.PAYMENT_RECHECK_INTERVAL)
            })
            .catch(err => {
              console.log(err)
              this.showErrorModal()
              this.paymentMethod = ''
              setTimeout(() => {
                this.paymentMethod = 'paypal'
              }, 500)
              reject(err)
            })
        })
      },
      paypalOnCancel (data, actions) {
        this.submitting = false
        this.$store.state.ws.removeEventListener('message', this.handlePaypalCreatePaymentResult)
        this.$store.state.ws.removeEventListener('message', this.handlePaypalExecutePaymentResult)
        this.$store.dispatch('resetPayment')
        this.$modal.hide()
      },
      isControlKey (key) {
        return 'Backspace,Tab,Enter,Meta,ArrowLeft,Left,ArrowRight,Right'.split(',').indexOf(key) !== -1
      },
      getEventKey (event) {
        return this.$utils.getEventKey(event)
      },
      validateCreditCardHolderKey (event) {
        let allowedKeys = 'Backspace,Tab,Enter,Meta'.split(',')
        let eventKey = this.getEventKey(event)

        if (!eventKey || event.metaKey) {
          return
        }

        if (allowedKeys.indexOf(eventKey) === -1 && !this.isControlKey(eventKey) && !eventKey.match(/[ a-zA-Z.]/)) {
          event.preventDefault()
          return
        }
      },
      updateCreditCardHolder (event) {
        window.requestAnimationFrame(() => {
          this.ccHolderName = event.target.value.replace(/[^ a-zA-Z.]/g, '')
        })
      },
      validateCreditCardKey (event) {
        let allowedKeys = '0,1,2,3,4,5,6,7,8,9,Backspace,Tab,Enter,Meta,ArrowLeft,Left,ArrowRight,Right'.split(',')
        let eventKey = this.getEventKey(event)

        if (event.metaKey) {
          return
        }

        if (allowedKeys.indexOf(eventKey) === -1) {
          event.preventDefault()
          return
        }
        if (!this.isControlKey(eventKey) && this.ccNumber.replace(/\s+/g, '').length >= 16) {
          event.preventDefault()
          return
        }
      },
      updateCreditCardValue (event) {
        const originalValue = event.target.value.replace(/\s+/g, '')
        let value = originalValue.split('')
        let chunks = []
        chunks.push(value.splice(0, 4).join(''))
        if (value.length) chunks.push(value.splice(0, 4).join(''))
        if (value.length) chunks.push(value.splice(0, 4).join(''))
        if (value.length) chunks.push(value.splice(0, 4).join(''))

        window.requestAnimationFrame(() => {
          this.ccNumber = chunks.join(' ').trim().replace(/[^0-9 ]/g, '')
        })
      },
      validateExpiredKey (event) {
        let allowedKeys = '0,1,2,3,4,5,6,7,8,9,Backspace,Tab,Enter,ArrowLeft,Left,ArrowRight,Right'.split(',')
        let eventKey = this.getEventKey(event)

        if (!eventKey || event.metaKey) {
          return
        }

        if (allowedKeys.indexOf(eventKey) === -1) {
          event.preventDefault()
          return
        }

        if (!this.isControlKey(eventKey) && this.ccExpired.length >= 5) {
          event.preventDefault()
          return
        }

        if (this.ccExpired[this.ccExpired.length - 1] === '/' && eventKey === 'Backspace') {
          this.ccExpired = this.ccExpired.replace(/\/$/, '')
        }
      },
      updateExpiredValue (value) {
        if (value.match(/^[0-9]{0,2}\/[0-9]{0,2}$/)) {
          return
        }
        window.requestAnimationFrame(() => {
          this.ccExpired = value.replace(/[^0-9]/g, '').replace(/^([0-9]{2})\/?/, '$1/').slice(0, 5)
        })
      },
      validateCVVKey (event) {
        let allowedKeys = '0,1,2,3,4,5,6,7,8,9,Backspace,Tab,Enter'.split(',')
        let eventKey = this.getEventKey(event)

        if (event.metaKey) {
          return
        }

        if (allowedKeys.indexOf(eventKey) === -1) {
          event.preventDefault()
          return
        }

        if (!this.isControlKey(eventKey) && this.ccCVV.length >= 4) {
          event.preventDefault()
          return
        }
      },
      saveProfile () {
        const user = this.$store.state.user
        const payload = {
          email: user.email,
          firstName: user.firstName,
          lastName: user.lastName,
          telNo: user.telNo,
          address: {
            address: this.address,
            province: this.province,
            postcode: this.postcode
          },
          shippingContact: {
            email: this.email,
            firstName: this.info.firstName,
            lastName: this.info.lastName,
            telNo: this.info.phone
          }
        }

        this.$http.post('members/profile', payload)
          .catch(err => {
            console.log(err)
          })
      },
      submit ($event) {
        // cleansing e-mail
        this.email = this.$utils.cleanEmailInvisibleChars(this.email)

        if (!this.acceptPolicy) {
          this.$modal.show({
            title: 'การยอมรับข้อตกลงและเงื่อนไข',
            text: 'กรุณาอ่าน ข้อตกลงและเงื่อนไข ก่อนทำการบริจาค หากไม่ยอมรับเราจะไม่สามารถดำเนินการรับการบริจาคได้'
          })
          return
        }

        if (this.totalPrice === 0) {
          this.$modal.show({
            title: 'มีบางอย่างไม่ถูกต้อง',
            text: 'จำนวนรายการไม่สามารถเป็นศูนย์ได้ กรุณาเลือกรายการใหม่หรือเพิ่มจำนวนก่อนทำรายการ'
          })
          return
        }

        if (!this.$v.validate()) {
          console.log(this.$v.$errors)
          this.$forceUpdate()
          this.$utils.scrollToFirstErrors()
          return
        }

        // if (this.emailFormVisible) {
        //   let user = this.$store.state.user || {
        //     shippingContact: {}
        //   }
        //   user.shippingContact.email = this.email
        //   this.$store.dispatch('setUser', user)
        // }

        // check if contain Thai chars
        if (this.hasThaiCharacters(this.email) && !this.confirmThaiEmail) {
          this.$modal.show({
            title: 'แจ้งเตือน',
            text: `อีเมลของคุณมีอักขระไทยปรากฏอยู่ ( <em>${this.email}</em> ) คุณแน่ใจจะใช้อีเมลนี้หรือไม่`,
            cancelButton: true,
            ok: () => {
              this.confirmThaiEmail = true
              this.submit($event)
            }
          })
          return
        }

        const checkoutInfo = {
          email: this.email,
          phone: this.phone,
          needReceipt: this.needReceipt,
          needReceiptShipping: this.needReceiptShipping,
          taxId: this.taxId.replace(/[^0-9]/g, ''),
          fullname: this.fullname,
          receiptAddress: this.receiptAddress,
          receiptProvince: this.receiptProvince,
          receiptPostalCode: this.receiptPostalCode
        }
        this.$store.dispatch('updateCheckoutInfo', checkoutInfo)

        // if (this.addressFormVisible) {
        //   if (!this.$refs.addressForm.validate()) {
        //     this.$forceUpdate()
        //     this.$utils.scrollToFirstErrors()
        //     return
        //   }
        //   this.$refs.addressForm.submit()
        //   if (this.$store.state.user && this.$store.state.user.uuid) {
        //     this.saveProfile()
        //   }
        // }

        if (this.submitting) {
          return
        }
        this.submitting = true
        this.showProgressModal()
        this.$store.dispatch('setPaymentMethod', this.paymentMethod)

        if (this.isPaypal) {
          return true
        }

        switch (this.paymentMethod) {
          case 'credit_card':
            // this.payByOmiseCreditCard()
            if (this.$store.state.donateType === 'monthly' || this.$store.state.donateType === 'daily') {
              this.payByPaco()
            } else {
              this.payByTMBCreditCard({
                payment_method: 'credit_card'
              })
            }
            break
          case 'internet_banking':
            this.payByOmiseInternetBanking()
            break
          case 'bank_transfer':
            this.payByTransfer()
            break
          case 'cheque':
            this.payByCheque()
            break
          case 'paypal':
            this.payByPaypal()
            break
          case 'line_pay':
            this.payByLinePay()
            break
          case '2c2p:123':
            this.payBy2c2pInternetBanking()
            break
          case 'thaiqr':
            this.payByThaiQR()
            break
        }
      }
    }
  }

</script>

<style scoped lang="less">
  .payment-page.bank_transfer {
    padding-bottom: 152px;
  }
  button {
    width: 100%;
  }
  .empty-cart {
    padding: 15px;
  }
  .txt-normal {
    font-size: 20px;
    font-weight: 300;
  }
</style>

<style lang="scss">
  .thaiqr-instruction ol {
    font-family: "Wittaya-Light", Arial, sans-serif;
    text-align: left;
  }

  #paypal-button2 .paypal-button-container .paypal-button-parent {
    width: 100%;
  }
  .block__img__wrapper {
    margin-left: 10px;
  }
  .block__img__wrapper:last-child {

  }
  .form__label--note {
    display: inline-block;
    margin-left: 25px;
    @media (min-width: 768px) {
      + .block--icon-bank {
        margin-top: -25px;
        width: 30%;
      }
    }
  }

  @media (max-width: 767px) {
    .promptpay__wrapper {
      flex-wrap: wrap;
      .ic-promptpay { margin-bottom: 10px; }
      .promptpay--detail { padding-left: 0 !important;}
    }
    .block__img__wrapper {
      margin-left: 0;
      margin-right: 10px;
    }
  }
  .promptpay__wrapper {
    border-bottom: #dfdfdf solid 1px;
    padding-bottom: 18px;
    .promptpay--detail {
      padding-left: 10px;
    }

  }

  button.btn-confirm:disabled {
    // opacity: 0.7;
    background: #D6D6D6;
    border: #D6D6D6;
    color: white;
    opacity: 1;
    &:hover {
      background: #D6D6D6;
      border: #D6D6D6;
      color: white;
      box-shadow: none;
      opacity: 0.9;
    }
  }

  .receipt-shipping-info {
    border: 2px solid #ddd;
    border-radius: 5px;
    padding: 16px;
  }
</style>



// WEBPACK FOOTER //
// Payment.vue?56c0ddb8